import React, { useEffect, useState } from 'react';
import { actionsType } from 'config/constants';
import PubSub from 'services/PubSub/';
import PropTypes from 'prop-types';
import LoginService from 'services/Login';
import FavoritesStore from 'stores/new/Favorites';
import FavoritesActions from 'actions/Favorites';
import styles from './style.scss';

let actions = [];

const FavoriteButton = (props) => {
    const {sku, favorites} = props;
    const [isLogged, setIsLogged] = useState(false)
    const [isFavorite, setFavorite] = useState(false)
    const [view, setView] = useState(true)

    useEffect(() => {
        validateSession();
        actions.push(PubSub.register(actionsType.LOGGED_IN, validateSession));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, [])

    useEffect(() => {
        const _favorites = favorites && favorites.favorites;
        setFavorite(Array.isArray(_favorites) && _favorites.includes(sku));

        if(favorites){
            setView(!favorites.loading)
        }
    }, [favorites])

    const validateSession = () => {
        if (LoginService.isLogged()) {
            setIsLogged(true);
        }
    }
    
    const updateFavorites = () => {
        setFavorite(!isFavorite)
        if(isFavorite) {
            FavoritesActions.removeFavorite(sku);

            setTimeout(() => {
                PubSub.dispatch('open_snackbar', {
                    Subtitle: `<span class="snackbar-favorite-product">Eliminaste este producto de tus favoritos</span>`,
                    timer: 5000,
                    type: 'deletedProductFavorite',
                });
            }, 0);
            
        } else {
            FavoritesActions.addFavorite(sku);

            setTimeout(() => {
                PubSub.dispatch('open_snackbar', {
                    Subtitle: `<span class="snackbar-favorite-product">¡Agregaste este producto a tus favoritos!</span>`,
                    timer: 5000,
                    type: 'addProductFavorite',
                });
            }, 0);
        }
    }

    if (!(isLogged && view)) return false;

    return (
        <div className="favorite-product-content">
            <button className="favorite-product-button mobile-click" onClick={updateFavorites}>
                <i className={`favorite-product-icon  ${isFavorite ? 'is-favorite jumbo-icon-heart-filled ' : 'jumbo-icon-new-heart '}`}></i>
            </button>
        </div>
    )
}


FavoriteButton.propTypes = {
    sku: PropTypes.string,
    favorites: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.bool,
    ]),
    position: PropTypes.number,
    type: PropTypes.string
};
export default FavoritesStore.wrapConsumer(FavoriteButton)